var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"counter"}},[_c('h2',[_vm._v(" Ayyye yo Counter component got itself inserted!!! ")]),_c('h3',[_vm._v(" My counter be "+_vm._s(_vm.count)+"!! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }